export default __webpack_public_path__ + "static/media/space_object_09-min.9e7a207b.png";